import React from 'react';
import { connect } from "react-redux";

const ProductInfo = ({...props}) => {    
    return (
        <>
            <div className="container p-0">
                <hr className="divider" />
                <div className="row productInfoContent">
                    <div className="col-md-6">
                        <h6><b>Kích thước và chiều cao</b></h6>
                        <div>
                            <div>Chiều cao: {props.product.height} cm</div>
                            <div>Chiều rộng: {props.product.width} cm</div>
                            <div>Chiều dài: {props.product.length} cm</div>
                        </div>
                    </div>            
                    <div className="col-md-6">
                        <h6><b>Chất liệu</b></h6>
                        <div>
                            <div>Chất liệu: {props.product.material}</div>
                            <div>Màu sắc: {props.product.color} </div>
                        </div>
                    </div>            
                </div>
                <div className="row productInfoSpacing productInfoContent">
                    <div className="col-md-6">
                        <h6><b>Đặc điểm nổi bật</b></h6>
                            <div>{props.product.notes}</div>
                    </div>
                    <div className="col-md-6">
                        <h6><b>Mã sản phẩm</b></h6>
                        <div>
                            <div>#{props.product.productId}</div>
                        </div>
                    </div>        
                </div>    
                <hr className="divider" />
                <div className="text-center" style={{ padding: '1%' }}> 
                    <p><b>{props.templates.templates.templateProperties.product_detail_note_first}</b></p>
                    <p><b>{props.templates.templates.templateProperties.product_detail_note_second}</b></p>  
                </div>      
            </div>
        </>
    )
};

const mapStateToProps = (state) => {
    return {
      user: state.user,
      templates: state.templates,
    };
  };
  
  export default connect(mapStateToProps)(ProductInfo);